import { useElsewhereRecordsQuery } from '@platform/engine/insights/elsewhereRecordsApi';
import { useGetStatsQuery, useMeQuery } from '@platform/state/api';
import { analysisModuleKey, kindField } from './designSections';

/**
 * Простір, з якого «Проєктування» модуля бере записи бізнес-аналізу (прототип v4 baFor: src — поточний простір, якщо в ньому є записи
 * аналізу, інакше перший інший простір користувача з ними, а без такого — знову поточний). Undefined — ще визначається.
 */
export function useAnalysisSource(ws: string, skip = false): string | undefined {
  const { data: own } = useGetStatsQuery({ ws, rt: analysisModuleKey, by: kindField, params: {} }, { skip: skip || !ws });
  const empty = own?.total === 0;
  const { data: me } = useMeQuery(undefined, { skip: skip || !empty });
  const candidates = (me?.workspaces ?? []).filter((w) => w.id !== ws).map((w) => w.id);
  const { data: other, isSuccess } = useElsewhereRecordsQuery({ rt: analysisModuleKey, candidates }, { skip: skip || !empty || !candidates.length });
  if (skip || !own) return undefined;
  if (!empty) return ws;
  if (!me) return undefined;
  if (!candidates.length) return ws;
  return other ? other.ws : isSuccess ? ws : undefined;
}
